import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Help = ({ style }: SvgProps) => {
  const { primaryColorToUse, secondaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 22'
    >
      <g clipPath='url(#op02cud50a)'>
        <path
          stroke={primaryColorToUse}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.501'
          d='M7.954 7.878a2.625 2.625 0 0 1 5.101.875c0 1.75-2.625 2.625-2.625 2.625m.07 3.5h.009m8.74-4.375a8.75 8.75 0 1 1-17.498 0 8.75 8.75 0 0 1 17.499 0z'
        />
      </g>
      <defs>
        <clipPath id='op02cud50a'>
          <path fill={secondaryColorToUse} d='M0 0h20.998v20.998H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};
